// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `page-layout-simple {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  width: 100%;
  min-height: 0;
}
.flex-tall {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./app/components/page-layout-simple/page-layout-simple.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AACJ;AAIA;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;AAFJ","sourcesContent":["page-layout-simple {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    height: 100%;\n    width: 100%;\n    min-height: 0;\n}\n\n// This utility class is needed to help elements fill the height of their parent\n// because height: 100% on a flex child in safari 9 and 10 doesn't work properly\n.flex-tall {\n    display: flex;\n    flex-direction: column;\n    flex: 1; // Support: Safari 10 - height 100% doesn't work\n    min-height: 0; // Support: Firefox - otherwise elements will be too tall\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
